import styled from 'styled-components';
import { colors } from '../../../theme';

export const StyledCustomDropdown = styled.div`
  position: relative;
  display: inline-block;
  margin-right: 16px;
`;

// on hover show dropdown
export const StyledCustomButton = styled.button`
  display: flex;
  align-items: center;
  padding: 4px 6px;
  background-color: ${colors.main.white};
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 100px;
  height: 40px;

  &:hover {
    background-color: #f7fafc;
    border-color: #cbd5e0;
  }
`;

export const StyledCustomPanel = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  background-color: ${colors.main.white};
  border-radius: 12px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: calc(100% + 5rem);
  animation: slideDown 0.2s ease;

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    min-width: 250px;
    right: -20px;
  }
`;

export const StyledCustomGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StyledCustomItem = styled.div`
  padding: 4px 6px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: ${(props) => (props.isSelected ? '#EBF8FF' : 'transparent')};
  border: 2px solid ${(props) => (props.isSelected ? '#3182CE' : 'transparent')};

  &:hover {
    background-color: ${(props) => (props.isSelected ? '#EBF8FF' : '#F7FAFC')};
    border-color: ${(props) => (props.isSelected ? '#3182CE' : '#E2E8F0')};
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const StyledCustomIcon = styled.span`
  font-size: 20px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;
